import { render } from "./LabCasesDetails.vue?vue&type=template&id=3836e11a&scoped=true"
import script from "./LabCasesDetails.vue?vue&type=script&lang=js"
export * from "./LabCasesDetails.vue?vue&type=script&lang=js"

import "./LabCasesDetails.vue?vue&type=style&index=0&id=3836e11a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3836e11a"]])

export default __exports__